// this file is generated by update_shopify_store_data.py at 2026-06-22 20:28:17.635159
var courses = [
    {
        "course_id": "2FDCC152-8488-EE11-9987-005056A725AD",
        "course_version": 1,
        "name": "ANA: APRN Pharmacology Today: Understanding Herbal, Vitamin, and Mineral Supplements",
        "course_type": 1,
        "author_information": "",
        "description": "Overview\r\nYou will focus on the efficacy, safety, and drug interactions of the most used vitamins, over-the-counter products, and herbal supplements in this course. Advanced Practice Registered Nurses (APRN) like you will also benefit from a review of key drug-food interactions, how to evaluate sources for best practice guidelines, and differentiate key issues pertaining to special populations. You will also gain insight into methods of interviewing patients to get an accurate account of their vitamin and supplement use.",
        "learning_objectives_html": "At the conclusion, participants should be able to:\r\n<ul>\r\n    <li>Appraise the most commonly used herbal supplements and vitamins in the United States</li>\r\n    <li>Analyze the efficacy, safety, and drug interactions of common vitamins, over-the-counter medications, and herbal supplements</li>\r\n    <li>Apply components of patient counseling to secure key information from patients regarding vitamins, over-the-counter medications, and herbal supplements</li>\r\n    <li>Differentiate key issues pertaining to special populations</li>\r\n</ul>",
        "course_outline_html": "",
        "credit_info": "-",
        "categories": [
            {
                "course_category_id": "5EC7EE02-0083-EE11-9986-005056A740BF",
                "course_category_name": "ANA - American Nurses Association",
                "is_system_course_category": null
            },
            {
                "course_category_id": "8FAC2CA7-C884-EE11-998F-005056A7C6AF",
                "course_category_name": "ANA - American Nurses Association",
                "is_system_course_category": null
            },
            {
                "course_category_id": "9D089F81-80D3-EF11-9991-005056A78EAA",
                "course_category_name": "ANA - ANA APRN Pharmacology Bundle - Courses",
                "is_system_course_category": null
            },
            {
                "course_category_id": "7C6F7677-8F9E-E511-9627-005056B1456A",
                "course_category_name": "Nurse Practitioner",
                "is_system_course_category": null
            },
            {
                "course_category_id": "18DBACB6-C884-EE11-998F-005056A7C6AF",
                "course_category_name": "ANA - American Nurses Association",
                "is_system_course_category": null
            },
            {
                "course_category_id": "1F4B1A8B-1EC9-E511-8771-005056B104B1",
                "course_category_name": "Nurse Midwife",
                "is_system_course_category": null
            },
            {
                "course_category_id": "41A45D8A-264F-DB11-9011-000423ACEF71",
                "course_category_name": "Pharmacology",
                "is_system_course_category": null
            },
            {
                "course_category_id": "C98E2D7E-1EC9-E511-8771-005056B104B1",
                "course_category_name": "Nurse Anesthetist",
                "is_system_course_category": null
            }
        ],
        "ce_accreditation": {
            "accrediting_body_name": "ANCC",
            "accreditation_statement": "American Nurses Association is accredited with distinction as a provider of nursing continuing professional development by the American Nurses Credentialing Center's Commission on Accreditation.",
            "course_level_accreditation_statement": "",
            "credit_display_name": "ANCC CNE Credit",
            "credit_units": 4.5,
            "credit_unit_display_name": "ANCC Contact\r\nHour(s)"
        },
        "sub_courses": []
    }
];